/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A range is more realistic: healthy weight depends on muscle, frame and other factors. Use the range as a guide, not a strict target.`)
};

const es_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un rango es más realista: el peso saludable depende de la masa muscular, el marco y otros factores. Usa el rango como guía, no como objetivo estricto.`)
};

const de_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bereich ist realistischer: gesundes Gewicht hängt von Muskel, Rahmen und anderen Faktoren ab. Verwenden Sie den Bereich als Anleitung, nicht als strenger Zielwert.`)
};

const nl_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een bereik is realistischer: gezond gewicht hangt af van spier, frame en andere factoren. Gebruik het bereik als gids, niet als streng doel.`)
};

const fr_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une plage est plus réaliste : le poids santé dépend de la masse musculaire, de la charpente et d'autres facteurs. Utilisez la plage comme guide, pas comme un objectif strict.`)
};

const it_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un intervallo è più realistico: il peso sano dipende dalla muscolatura, dal frame e da altri fattori. Usa l'intervallo come guida, non come un target rigoroso.`)
};

const pt_br2_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma faixa é mais realista: peso saudável depende de músculo, quadro e outros fatores. Use a faixa como guia, não como alvo rígido.`)
};

const pt_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um intervalo é mais realista: o peso saudável depende de músculo, esqueleto e outros fatores. Use o intervalo como guia, não como alvo rigoroso.`)
};

const ja_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`範囲はより現実的です。健康的な体重は筋肉、フレーム、その他の要因に依存します。範囲をガイドとして使用し、厳密なターゲットではなく使用します。`)
};

const zh_hw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`范围更贴近现实：健康体重取决于肌肉量、体型等多种因素。请将该范围当作参考，而非严格的目标。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq2_a", locale)
	if (locale === "en") return en_hw_faq2_a(inputs)
	if (locale === "es") return es_hw_faq2_a(inputs)
	if (locale === "de") return de_hw_faq2_a(inputs)
	if (locale === "nl") return nl_hw_faq2_a(inputs)
	if (locale === "fr") return fr_hw_faq2_a(inputs)
	if (locale === "it") return it_hw_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq2_a(inputs)
	if (locale === "pt") return pt_hw_faq2_a(inputs)
	if (locale === "ja") return ja_hw_faq2_a(inputs)
	return zh_hw_faq2_a(inputs)
};